const OverlayManager = {
  namespaced: true,

  state: {
    messages: [],
  },

  actions: {
    addMessage({ commit, state }, { text, color, icon }) {
      const existing = state.messages.find(msg => msg.text === text);
      if (existing) {
        const id = existing.id;
        clearTimeout(existing._timer);
        existing._timer = setTimeout(() => commit('toRemoveItem', id), 10000);
        return; 
      }
      const id = Date.now();
      commit('toAddNewItem', { id, text, color, icon });
      const message = state.messages.find(msg => msg.id === id);
      message._timer = setTimeout(() => commit('toRemoveItem', id), 10000);
    }
  },

  mutations: {
    toAddNewItem(state, { id, text, color, icon }) {
      state.messages.push({ id, text, color, icon });
    },

    toRemoveItem(state, id) {
      state.messages = state.messages.filter(item => item.id !== id);
    }
  },

  getters: {
    //Все сообщения
    allMessages: state => state.messages,
  }
};

export default OverlayManager;